import { WorkflowTemplate } from "./WorkflowTemplate";
import { WorkflowTest } from "./WorkflowTest";
export class WorkflowTemplateListScreenData {
    
    templates: WorkflowTemplate[];
    tests: WorkflowTest[];
    template_headers: Object;
    test_headers: Object;
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    totalItems: number;
    sort_by: string;
    limit: number;
    offset: number;
    selected_test:WorkflowTest;
    detail_test_pop_up :boolean;
    loading_test: boolean;
    //snackbar: Object;
    constructor(){
        this.templates = []
        this.template_headers = [
            {
                text: "Id",
                sortable: true,
                value: "id",
            },
            {
                text: "Nombre",
                sortable: true,
                value: "name",
            },
            {
                text: "Tipo",
                sortable: false,
                value: "type",
            }
        ]
        this.tests = []
        this.test_headers = [
            {
                text: "Id",
                sortable: true,
                value: "id",
            },
            {
                text: "Workflow",
                sortable: true,
                value: "workflow_template_id",
            },
            {
                text: "Nombre",
                sortable: true,
                value: "name",
            },
            {
                text: "Estado",
                sortable: false,
                value: "state",
            },
            {
                text: "Última ejecución",
                sortable: true,
                value: "last_run",
            },
            {
                text: "Passed",
                sortable: true,
                value: "passed",
            },
            {
                text: "Ejecutar",
                sortable: false,
                value: "run",
            },
        ]
        this.selectedItems = []
        this.loadingItems = false
        this.footerItemsPerPageText = "Items por página"
        this.footerItemsPerPageOptions = [5, 10, 20, 50, 100]
        this.showSelect = false
        this.textNoResults = "No se encontraron resultados"
        this.textLoading = "Cargando..."
        this.itemKey = "id"
        this.hideHeaderCheckbox = false
        this.totalItems = 0
        this.sort_by = "-id"
        this.limit = 50
        this.offset = 0
        //this.snackbar = {}
        this.selected_test = null;
        this.detail_test_pop_up = false;
        this.loading_test = false;
    }

    setTemplates(templates: WorkflowTemplate[]){
        this.templates = templates
    }

    setTests(tests: WorkflowTest[]){
        this.tests = tests
    }


}